export type BrandConfig = {
  brandName: string;
  NDD: string;
  sameAs: string[] | undefined;
  logo: string;
  ogImage: string;
  brandDescription: string;
  contactPoint: {
    contactType: string;
    email: string;
    telephone: string;
    availableLanguage: string[];
  };
  address: {
    streetAddress: string;
    addressLocality: string;
    addressCountry: string;
    addressRegion: string;
    postalCode: string;
  };
  vatID: string;
  isResellerBrand: boolean;
  showPrices: boolean;
  allowOnlinePurchase: boolean;
  mainCTA: { label: string; path: string };
  resellerCTA: { label: string; path: string };
  becomeResellerCTA: { label: string; path: string };
  salesChannelLabel: string;
};

export const brandConfig: BrandConfig = {
  brandName: "KaiserSafe",
  NDD: "https://kaisersafe.com",
  logo: "https://kaisersafe.com/KaiserSafeLogo.webp",
  brandDescription:
    "KaiserSafe est un fabricant renommé d'armoires à fusils et coffres forts, offrant une protection fiable pour vos biens précieux.",
  sameAs: [],
  contactPoint: {
    contactType: "sales",
    email: "contact@kaisersafe.com",
    telephone: "+33785756439",
    availableLanguage: ["fr"],
  },
  address: {
    streetAddress: "11 Rue Raspail",
    addressLocality: "Cachan",
    addressCountry: "FR",
    addressRegion: "Ile-de-France",
    postalCode: "94230",
  },
  vatID: "FR65330754045",
  ogImage: "/public/KaiserSafeLogo.webp",
  isResellerBrand: true,
  showPrices: true,
  allowOnlinePurchase: false,
  mainCTA: {
    label: "Découvrir nos modèles",
    path: "/produits",
  },
  resellerCTA: {
    label: "Liste de nos revendeurs",
    path: "/revendeurs",
  },
  becomeResellerCTA: {
    label: "Devenir revendeur",
    path: "/contact",
  },
  salesChannelLabel: "Disponible chez les armuriers partenaires",
};
